var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticStyle: { padding: "0 40px" } },
        [
          _c("span", { staticClass: "title-h4" }, [
            _vm._v(_vm._s(_vm.$t("titleSearch.title"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("titleSearch.refNo"),
                            prop: "refNo",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "titleSearch.placeholderRefNo"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.refNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "refNo", $$v)
                              },
                              expression: "form.refNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          staticStyle: { "margin-top": "30px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.toSearch },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.search")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.isResult
      ? _c(
          "div",
          { staticClass: "result-container" },
          [
            _c("h4", [_vm._v(_vm._s(_vm.$t("dangerCargo.result")))]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.refInfo, border: "", stripe: "" },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "20px" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "refNo",
                    label: _vm.$t("dangerCargo.refNo"),
                    "min-width": "12%",
                    "show-overflow-tooltip": "true",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    label: _vm.$t("dangerCargo.status"),
                    "min-width": "8%",
                    "show-overflow-tooltip": "true",
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.isCnLang
                                    ? _vm.statusTypeName[scope.row.status]
                                    : _vm.statusTypeEN[scope.row.status]
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3941802151
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "voyage",
                    label: _vm.$t("dangerCargo.vvl"),
                    "min-width": "10%",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "pol",
                    label: _vm.$t("speContainer.pol"),
                    "min-width": "8%",
                    "show-overflow-tooltip": "true",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "pod",
                    label: _vm.$t("speContainer.pod"),
                    "min-width": "8%",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "applyPerson",
                    label: _vm.$t("dangerCargo.applyPerson"),
                    "min-width": "12%",
                    "show-overflow-tooltip": "true",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "applyDate",
                    label: _vm.$t("dangerCargo.applyDate"),
                    "min-width": "11%",
                    formatter: _vm.formatDate,
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "isMix",
                    label: _vm.$t("dangerCargo.mix"),
                    "min-width": "7%",
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.isCnLang
                                  ? scope.row.isMix === 1
                                    ? "是"
                                    : "否"
                                  : scope.row.isMix === 1
                                  ? "Yes"
                                  : "No"
                              ) + "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    543332991
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "containerQuantity",
                    label: _vm.$t("dangerCargo.CNTRQuantity"),
                    "min-width": "7%",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "classType",
                    label: _vm.$t("dangerCargo.IMOClass"),
                    "min-width": "8%",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "seriseNo",
                    label: _vm.$t("dangerCargo.UNNo"),
                    "min-width": "8%",
                    align: "center",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("h4", [_vm._v(_vm._s(_vm.$t("speContainer.result")))]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "70%" },
                attrs: {
                  data: _vm.specialContainerInfo,
                  border: "",
                  stripe: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "20px" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "refNo",
                    label: _vm.$t("speContainer.refNo"),
                    "min-width": "12%",
                    "show-overflow-tooltip": "true",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    label: _vm.$t("dangerCargo.status"),
                    "min-width": "8%",
                    "show-overflow-tooltip": "true",
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.isCnLang
                                    ? _vm.statusTypeName[scope.row.status]
                                    : _vm.statusTypeEN[scope.row.status]
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3941802151
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "vvl",
                    label: _vm.$t("dangerCargo.vvl"),
                    "min-width": "10%",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "pol",
                    label: _vm.$t("speContainer.pol"),
                    "min-width": "8%",
                    "show-overflow-tooltip": "true",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "pod",
                    label: _vm.$t("speContainer.pod"),
                    "min-width": "8%",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "applyPerson",
                    label: _vm.$t("speContainer.applyPerson"),
                    "min-width": "12%",
                    "show-overflow-tooltip": "true",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "applyDate",
                    label: _vm.$t("speContainer.applyDate"),
                    "min-width": "11%",
                    formatter: _vm.formatDate,
                    align: "center",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }